/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import Backbone from 'backbone';
import ChartTypeModel from '../model/ChartTypeModel';

export default Backbone.Collection.extend({
    model: ChartTypeModel,
    initialize: function () {
    }
});
